import React from 'react';
import { connect, ConnectedProps } from '@cerebral/react';
import { sequences } from 'app/pwa/app.cerebral';
import { useText } from 'common/hooks';

import { Button } from './elements';
import { Container } from '../common/elements';

const deps = {
  goalModalClicked: sequences`challenge.info.goalModalClicked`,
};

export function SetGoal({
  goalModalClicked,
}: typeof deps & ConnectedProps): React.ReactElement {
  const t = useText();

  return (
    <Container>
      <Button onClick={() => goalModalClicked()}>
        {t('challenge.ChaPaD24B.PersonalInsights.goals.set_goal')}
      </Button>
    </Container>
  );
}

export default connect(deps, SetGoal);
